<template>
  <div class="contacts-tracking-card">
    <div class="contacts-tracking-card__count"
         :class="{'contacts-tracking-card__count_opacity': checkedList.length}"
    >
      {{checkedList.length}} selected
    </div>
    <ContactsTrackingTable :rows="rows"
                           :columns="columns"
                           :scroll="scroll"
                           :noData="noData"
                           :page="page"
                           :showLanguages="showLanguages"
                           :checkboxValue="checkboxValue"
                           :checkedList="checkedList"
                           :allChecked="allChecked"
                           :listCheckbox="listCheckbox"
                           :choseChecked="choseChecked"
                           @getAll="checkedAll"
                           @changeChecked="changeChecked"
                           @clickItem="choseOperation"
                           @languageFilter="setFilterLanguage"
                           @filter="setFilter"
                           @update="updateComment"/>
    <Pagination :data="fullInfo" :getQuery="getCompanies" :limit="page.defLimit" :sticky="true" class="bb-pagination"/>
  </div>
</template>

<script>
import ContactsTrackingTable
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingTable/ContactsTrackingTable'
import Pagination from '@/components/Main/Pagination/Pagination'
import {trackingCardsTableColumns} from '@/constants/TablesOptions/contactsTrackingList/trackingCardsTable'
import ContactCompaniesApi from '@/api/ContactCompanies/api'
import {cloneDeep, findIndex, get, set, find} from 'lodash'
import {expireStatus} from '@/constants/expireStatus'
import placesOfRegistration from '@/constants/placesOfRegistartion'
import setLanguageFilter from '@/mixin/setLanguageFilter'

export default {
  name: 'ContactsTrackingCard',
  props: ['filterByDate', 'scroll', 'status', 'valueSearch'],
  mixins: [setLanguageFilter],
  components: {
    ContactsTrackingTable,
    Pagination
  },
  data () {
    return {
      rows: [],
      columns: trackingCardsTableColumns,
      fullInfo: {},
      page: {
        defLimit: 50,
        currentPage: 1
      },
      noData: false,
      statuses: [],
      formedInList: [],
      filterByFormedIn: '',
      showLanguages: true,
      filterByStatus: '',
      filterByLanguage: [],
      checkedList: [],
      totalDocs: 0,
      listCheckbox: ['All tabs', 'Deselect all'],
      lang: ''
    }
  },
  computed: {
    emailStore: {
      get () {
        return this.$store.getters.emailStore
      },
      set (data) {
        this.$store.dispatch('setEmailStore', data)
      }
    },
    allChecked () {
      return this.checkedList.length === this.totalDocs
    },
    choseChecked () {
      return this.checkedList.length > 0 && this.checkedList.length < this.totalDocs
    },
    checkboxValue () {
      return this.checkedList.length
    }
  },
  methods: {
    checkedAll () {
      if (this.allChecked) {
        this.checkedList = this.checkedList.filter(item => {
          const status = this.filterByStatus.split('&estCard.expireStatus[]=')
          const statusNumber = status.map(item => +item)
          const expireStatus = get(item, ['estCard', 'expireStatus'], 0)
          return !statusNumber.includes(expireStatus)
        })
        return
      }
      if (this.choseChecked) {
        const status = this.filterByStatus.split('&estCard.expireStatus[]=')
        const statusNumber = status.map(item => +item)
        const hasStatus = this.checkedList.some(item => {
          const expireStatus = get(item, ['estCard', 'expireStatus'], 0)
          return statusNumber.includes(expireStatus)
        })
        if (hasStatus) {
          this.checkedList = this.checkedList.filter(item => {
            const expireStatus = get(item, ['estCard', 'expireStatus'], 0)
            return !statusNumber.includes(expireStatus)
          })
          return
        }
      }
      this.getCompanies({limit: 99999, check: true})
    },
    changeChecked ({rowId, row}) {
      const index = findIndex(this.checkedList, {id: rowId})
      if (index !== -1) {
        this.checkedList.splice(index, 1)
      } else {
        this.checkedList.push(row)
      }
    },
    setFilter (data, item, column) {
      if (column.filterId === 'formedIn') {
        this.setFilterByFormedIn(data, item)
      } else {
        this.setFilterByStatus(data, item)
      }
      this.getCompanies({})
    },
    choseOperation (operation) {
      if (operation === 'All tabs') {
        if (!this.filterByDate) return
        const status = [1, 2, 3, 4]
        const filterByDate = 'estCard.estCardDate=' + this.filterByDate
        this.$emit('loader', true)
        ContactCompaniesApi.getContactCompanies({
          page: 1,
          limit: 999,
          filterByDate,
          estCardStatus: status.join('&estCard.expireStatus[]=')
        })
          .then((resp) => {
            this.checkedList = resp.data.clientcompanies
            this.$emit('loader', false)
          })
          .catch((e) => {
            this.$emit('loader', false)
            console.error(e)
          })
      }
      if (operation === 'Deselect all') {
        this.checkedList = []
      }
    },
    setFilterLanguage (value, type) {
      this.lang = this.setLanguageFilter(value, type, this.filterByLanguage)
    },
    setFilterByFormedIn (data, item) {
      const status = find(this.formedInList, {id: item.id})
      status.checked = data
      const checked = this.formedInList.filter(item => item.checked)
      const ids = checked.map(item => item.id)
      this.filterByFormedIn = ids.join('&formedIn[]=')
    },
    setFilterByStatus (data, item) {
      const status = find(this.statuses, {id: item.id})
      status.checked = data
      const checked = this.statuses.filter(item => item.checked)
      const ids = checked.map(item => item.id)
      if (!ids.length) {
        this.changeStatusTab()
        return
      }
      this.filterByStatus = ids.join('&estCard.expireStatus[]=')
    },
    changeStatusTab () {
      const filters = expireStatus.filter(item => [1, 2, 3].includes(item.id))
      const columnFilters = find(this.columns, {type: 'status'})
      if (columnFilters) {
        const hasFilters = this.status.statusKeys.includes(1)
        this.$set(columnFilters, 'filters', hasFilters ? filters : false)
      }
      this.filterByStatus = ''
      const ids = this.status.statusKeys
      this.filterByStatus = ids.join('&estCard.expireStatus[]=')
      if (!this.filterByDate) return
      this.getCompanies({})
    },
    getTotalDocs ({
      limit = 1,
      page = 1
    }) {
      if (!this.filterByDate) return
      const status = [1, 2, 3, 4]
      const filterByDate = 'estCard.estCardDate=' + this.filterByDate
      this.$emit('loader', true)
      ContactCompaniesApi.getContactCompanies({
        page,
        limit,
        filterByDate,
        estCardStatus: status.join('&estCard.expireStatus[]=')
      })
        .then((resp) => {
          this.$emit('loader', false)
          this.totalDocs = resp.data.totalDocs
        })
        .catch((e) => {
          this.$emit('loader', false)
          console.error(e)
        })
    },
    getCompanies ({limit = this.page.defLimit, page, check}) {
      if (!this.filterByDate) return
      this.page.currentPage = page || this.page.currentPage
      const sort = 'estCard.estCardDate'
      const filterByDate = 'estCard.estCardDate=' + this.filterByDate
      this.$emit('loader', true)
      ContactCompaniesApi.getContactCompanies({
        page,
        limit,
        sort,
        lang: this.lang,
        filterByDate,
        formedIn: this.filterByFormedIn,
        estCardStatus: this.filterByStatus,
        search: this.valueSearch
      })
        .then((resp) => {
          if (check) {
            this.checkedList = this.checkedList.concat(resp.data.clientcompanies)
            this.$emit('loader', false)
            return
          }
          this.fullInfo = resp.data
          this.noData = resp.data.clientcompanies.length === 0
          this.rows = resp.data.clientcompanies
          this.$emit('loader', false)
        })
        .catch((e) => {
          this.$emit('loader', false)
          console.error(e)
        })
    },
    updateComment ({row, comment}) {
      const result = cloneDeep(row)
      result.client = get(row, 'client.id', '')
      result.license = row.license.map(item => item.id)
      const fileId = get(row, 'uploadFile.id', '')
      fileId ? result.uploadFile = fileId : delete result.uploadFile
      set(result, 'estCard.comment', comment)
      const index = findIndex(this.rows, {id: row.id})
      ContactCompaniesApi.updateContactCompany(result)
        .then((resp) => {
          if (index !== -1) {
            this.rows.splice(index, 1, resp.data)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  watch: {
    filterByDate () {
      this.getTotalDocs({})
      this.getCompanies({})
    },
    checkedList (newVal) {
      this.emailStore = newVal.map(item => item.client)
    },
    status () {
      this.changeStatusTab()
    },
    lang () {
      this.getCompanies({})
    },
    valueSearch () {
      this.getCompanies({})
    }
  },
  beforeMount () {
    this.statuses = cloneDeep(expireStatus)
    this.formedInList = cloneDeep(placesOfRegistration)
    this.changeStatusTab()
    this.getTotalDocs({})
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";
  .contacts-tracking-card {
    &__count {
      display: flex;
      justify-content: flex-end;
      padding-top: 4px;
      font-size: 12px;
      line-height: 14px;
      color: $color-silver;
      opacity: 0;

      &_opacity {
        opacity: 1;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingCategories/ContactsTrackingCard.vue